import React from 'react';
import { useDrag } from 'react-dnd';

const DraggableItem = ({ index, listIdx, children }) => {
  const [{ isDragging }, drag, preview] = useDrag({
    type: 'draggable-item',
    item: { listIdx, index },
    collect: monitor => ({
      isDragging: !!monitor.isDragging(),
    }),
  });

  return (
    <div className={`draggable-item ${isDragging ? 'is-dragging' : ''}`} ref={drag}>
      {children}
    </div>
  );
};

export default DraggableItem;
